export const skillsCsvTemplate = `value
Skill Name 1
Skill Name 2
Skill Name 3
etc
`;
